import { getAuthHeaders, tempMeeApi } from '~/services/api';
import type {
  IUpdateUserEducationApiPayload,
  TUpdateUserEducationApiResponse,
} from '../types/UpdateOffice.api';

export const updateUserEducation = async (
  payload: IUpdateUserEducationApiPayload,
): Promise<TUpdateUserEducationApiResponse> => {
  const headers = await getAuthHeaders();
  const { data } = await tempMeeApi.patch<TUpdateUserEducationApiResponse>(
    '/credential-service/user/credentials',
    payload,
    { headers },
  );
  return data;
};
